import React from 'react';
import DeliverySettings from '../../components/DeliverySettings';

const Deliveroo = () => {
	return (
		<DeliverySettings
			channelId="deliveroo"
			hasOpeningHours
			fields={[
				{
					id: 'brandId',
					label: 'Brand ID',
					placeholder: 'your-brand-ltd-gb'
				},
				{
					id: 'siteId',
					label: 'Site ID',
					readOnly: true,
					defaultValue: (shop) => shop?.id
				}
			]}
		/>
	);
};

export default Deliveroo;
